require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/regexp/escape.js
// module id = ./node_modules/core-js/fn/regexp/escape.js
// module chunks = 11056403903869698000